import newsbig from "../images/newsbig.svg";
import newssmall from "../images/newssmall.svg";

const Loading = () => {
    return (
        <div className="loading">
            <img src={newssmall} className="smallloading" alt="" />
            <img src={newsbig} className="bigloading" alt="" />
        </div>
    );
};

export default Loading;
